module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAACXBIWXMAAAsSAAALEgHS3X78AAABVElEQVRYhe3ZwW3CMBgF4FfUe1nCJ18yQkfoBoQNGAE26Ahhg47QEeDgky+MECYI+oNTuTRxk/ghGeEnIZIocr7EiZ0fXpqmQRurCwCfSCd161HmW0SvHlI2vCUElSwBvMvCwm04uU+y8bte9JU7ixQiF24DZeQW8KCJZ/EQyp+HiZXr7VMCOHRPKyu8rv87cuyhTMmCcrq+f3hbweqK0j4FGh6Dadg46LiJgoKdD502m0Vj50H7kcebvW7Xo7DTocPIdk728gVgzcJOg4aQbqr7FWUqFnY8dCqyCwk7DjoXScT+D41FkrBhKAtJwA5D2chIbOiKlnRkl2HsxxxocRdkl35sMbR76H20dFVp7ZcE1AjW6todC6EqmFuKWO03toMyW1bTD1OKZCg7GcpOhrKToexkKDsZyk6GsvO00L37PrufdGjh/9lgtZQTFZQ50NoEcAHT5JnEgWZyNwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/dn-10.png
// module id = TmTx
// module chunks = 1